import AbstractService from "../abstract.service";

export default class RetargetingSegmentsService extends AbstractService {
  static URI_STATES = new Map([
    ["retargeting_segments", "/retargeting_segments"],
    ["retargeting_segments.get", "/retargeting_segments/{0}"],
    ["retargeting_segments.put", "/retargeting_segments/{0}"],
  ]);

  /**
   * Get retargeting segments
   * @param {Object} params Query parameters
   * @returns {Promise<Object>} The retargeting segments response
   */
  async getRetargetingSegments(params = {}) {
    return await this.api_server.get(RetargetingSegmentsService.URI_STATES.get("retargeting_segments"), params);
  }

  /**
   * Get a specific retargeting segment
   * @param {number} segmentId
   * @returns {Promise<Object>} The retargeting segment response
   */
  async getRetargetingSegment(segmentId) {
    return await this.api_server.get(
      RetargetingSegmentsService.URI_STATES.get("retargeting_segments.get").format(segmentId),
    );
  }

  /**
   * Create a new retargeting segment
   * @param {Object} data The data for the new retargeting segment
   * @returns {Promise<Object>} The created retargeting segment response
   */
  async createRetargetingSegment(data) {
    return await this.api_server.post(RetargetingSegmentsService.URI_STATES.get("retargeting_segments"), data);
  }

  /**
   * Update a retargeting segment
   * @param {number} segmentId
   * @param {Object} data
   * @returns {Promise<Object>} The updated retargeting segment response
   */
  async updateRetargetingSegment(segmentId, data) {
    return await this.api_server.put(
      RetargetingSegmentsService.URI_STATES.get("retargeting_segments.put").format(segmentId),
      data,
    );
  }
}
